import { render, staticRenderFns } from "./CreateTask.vue?vue&type=template&id=67c6fe1f&scoped=true"
import script from "./CreateTask.vue?vue&type=script&lang=js"
export * from "./CreateTask.vue?vue&type=script&lang=js"
import style0 from "./CreateTask.vue?vue&type=style&index=0&id=67c6fe1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c6fe1f",
  null
  
)

export default component.exports